import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Owner-only line: which Solana RPC is live (type only, never the URL) + mint check.
export function WalletStatus() {
  const [s, setS] = useState(null);
  useEffect(() => { api.adminWalletStatus().then(setS).catch(() => {}); }, []);
  if (!s) return null;
  return (
    <div data-testid="admin-wallet-status" className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1 rounded-xl border border-am-border bg-am-surface/60 px-3 py-2 text-xs text-am-text2">
      <span>Solana RPC: <b className={s.rpc_degraded ? "text-aura-magenta" : "text-white"} data-testid="admin-wallet-rpc-mode">{s.rpc === "helius" ? (s.rpc_degraded ? "Helius endpoint failing (check SOLANA_RPC_URL key) — using public mainnet fallback" : "Helius (SOLANA_RPC_URL)") : "public mainnet (add SOLANA_RPC_URL for higher limits)"}</b></span>
      <span>· $AURAMAX mint: <b className={s.mint_info.ok ? "text-aura-mint" : "text-aura-magenta"}>{s.mint_info.ok ? `verified, ${s.mint_info.decimals} decimals` : (s.mint_info.error || "not verified")}</b></span>
      <span>· linked wallets: <b className="text-white">{s.linked_wallets}</b></span>
    </div>
  );
}
